import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=128e5626&"
import script from "./modal.js?vue&type=script&lang=js&"
export * from "./modal.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports